import { csx } from '@vtex/admin-ui'

export const styles = {
  flex: csx({
    width: '100%',
    display: 'flex',
    gap: '$space-3',
    '> div': {
      flex: 1,
    },
  }),
}
